import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'manConsStockStatus'
})
export class ManufacturerConsigneeStockTransfer implements PipeTransform {

  transform(value: Number) {
    let status = ''
    switch(value) {
      case 1:
        status = 'Dispatch To Aggregator';
        break;
      case 2:
        status = 'Returned By Aggregator';
        break;
      case 3:
        status = 'Closed';
        break;
      case 4:
        status = 'Cancelled';
        break;
    }
    return status;
  }

}
